import { useMutation } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type {
  PortfolioConsultationRequest,
  PortfolioConsultationResult,
  QuickCheckoutRequest,
  QuickCheckoutResult
} from "@/types/api";

/**
 * "Get Started" mutation — hits /api/checkout/quick and returns the
 * HostShop basket-direct URL. UI side: redirect via window.location
 * so the browser cleanly leaves SPA-land for the payment domain.
 */
export function useQuickCheckout() {
  return useMutation({
    mutationFn: (body: QuickCheckoutRequest) =>
      api.post<QuickCheckoutResult>("/api/checkout/quick", body)
  });
}

/** Portfolio Custom enquiry — saves a ContactRequest server-side. */
export function usePortfolioConsultation() {
  return useMutation({
    mutationFn: (body: PortfolioConsultationRequest) =>
      api.post<PortfolioConsultationResult>("/api/checkout/portfolio-consultation", body)
  });
}
